/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingposttype2Inputs */

const en_crosspostingposttype2 = /** @type {(inputs: Crosspostingposttype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post type`)
};

const de_crosspostingposttype2 = /** @type {(inputs: Crosspostingposttype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitragstyp`)
};

/**
* | output |
* | --- |
* | "Post type" |
*
* @param {Crosspostingposttype2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingposttype2 = /** @type {((inputs?: Crosspostingposttype2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingposttype2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingposttype2(inputs)
	return de_crosspostingposttype2(inputs)
});
export { crosspostingposttype2 as "crosspostingPostType" }